import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-cnae-erro-modal',
  templateUrl: './cnae-erro-modal.component.html',
  styleUrls: ['./cnae-erro-modal.component.scss']
})
export class CnaeErroModalComponent implements OnInit {
  cnaesCliente: string[];
  cnaesPremissas: string;

  administrador = false;
  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialogRef: MatDialogRef<CnaeErroModalComponent>,
    public globalService: GlobalService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {

  }

  async ngOnInit() {
    this.administrador = await this.globalService.administrador();
    this.cnaesCliente = this.data.cnaesCliente.join("/");
    this.cnaesPremissas = this.data.cnaesPremissas.map(p => p.code).join('/');
  }

  liberarSemCnae() {
    this.dialogRef.close({ liberarSemCnae: true });
  }

  fechar(){
    this.dialogRef.close();
  }

}
